module.exports = __webpack_public_path__ + "static/media/phone_calling.f9c33328.svg";